export function track({ category, action, label, value }) {
	if (!window.uetq || typeof window.uetq.push !== "function") {
		console.info("Bing tracker is not running. Could not track the event:", {
			category,
			action,
			label,
			value,
		});
		return;
	}

	window.uetq.push({
		ec: category || "",
		ea: action || "",
		el: label || "",
		ev: value || 0,
	});
}
